import { useEffect, useState } from 'react';

export const PHONE_DRAG_MEDIA_QUERY = '(max-width: 767.98px), (pointer: coarse)';
export const COMPACT_EDITOR_MEDIA_QUERY = '(max-width: 767.98px)';
export const COARSE_POINTER_MEDIA_QUERY = '(pointer: coarse)';

const getDeviceProfile = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return { isCompact: false, isCoarsePointer: false, canDrag: true };
  }

  const isCompact = window.matchMedia(COMPACT_EDITOR_MEDIA_QUERY).matches;
  const isCoarsePointer = window.matchMedia(COARSE_POINTER_MEDIA_QUERY).matches;
  return { isCompact, isCoarsePointer, canDrag: !isCompact && !isCoarsePointer };
};

/**
 * Native HTML dragging is unreliable on touch screens and competes with page
 * scrolling. Keep it available only for desktop-style fine pointer layouts.
 */
export const useEditorDeviceProfile = () => {
  const [profile, setProfile] = useState(getDeviceProfile);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;

    const compactQuery = window.matchMedia(COMPACT_EDITOR_MEDIA_QUERY);
    const coarsePointerQuery = window.matchMedia(COARSE_POINTER_MEDIA_QUERY);
    const updateProfile = () => setProfile((current) => {
      const next = getDeviceProfile();
      return current.isCompact === next.isCompact
        && current.isCoarsePointer === next.isCoarsePointer
        && current.canDrag === next.canDrag
        ? current
        : next;
    });
    updateProfile();
    compactQuery.addEventListener?.('change', updateProfile);
    coarsePointerQuery.addEventListener?.('change', updateProfile);

    return () => {
      compactQuery.removeEventListener?.('change', updateProfile);
      coarsePointerQuery.removeEventListener?.('change', updateProfile);
    };
  }, []);

  return profile;
};

export const useEditorDragCapability = () => useEditorDeviceProfile().canDrag;

export default useEditorDragCapability;
